import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'antd';
import Button from '../../common/Button';

import './styles.scss';

interface ConfirmModalProps {
    isModalOpen: boolean;
    handleCancel: () => void;
    handleOk: () => void;
    className: string;
    title: string;
    teamData: Record<string, string>;
    footerInfo: string;
    selectTeamBonusInfo: string;
}

const ConfirmModal: FC<ConfirmModalProps> = ({
     isModalOpen,
     handleCancel,
     handleOk,
     className,
     title,
     teamData,
     footerInfo,
     selectTeamBonusInfo,
    }) => {
    const { t } = useTranslation();
    return (
        <>
            <Modal
                className={className}
                title={t(title)}
                centered
                closable={false}
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={
                    <>
                        <div className={'buttonsContainer'}>
                            <Button onClick={handleOk} className={'button confirmButton'}>
                                {t('confirm')}
                            </Button>
                            <Button onClick={handleCancel} className={'button cancelButton'}>
                                {t('cancel')}
                            </Button>
                        </div>
                        <p dangerouslySetInnerHTML={{ __html: t(footerInfo) || '' }} />
                    </>
                }
            >
                <p dangerouslySetInnerHTML={{ __html: t(selectTeamBonusInfo) || '' }} />
                <p className={'teamInfo'}>
                    <img src={teamData.url} alt={teamData.name} width={20} />
                    <span> {teamData.name}</span>
                </p>
            </Modal>
        </>
    );
};

export default ConfirmModal;
